import { Leaf } from "lucide-react";

const ITEMS = [
    "Piscina spa aquecida",
    "Café da manhã e jantar inclusos",
    "Pet friendly",
    "Vista da Serra da Moeda",
    "Hidromassagem",
    "Cascata particular",
    "Decoração romântica",
    "Natureza e descanso",
];

export default function Marquee() {
    const content = [...ITEMS, ...ITEMS];
    return (
        <div data-testid="marquee-strip" className="overflow-hidden border-y border-stone-200 bg-[#EAE6DF] py-5">
            <div className="flex whitespace-nowrap animate-marquee w-max">
                {content.map((item, i) => (
                    <span key={i} className="flex items-center gap-6 px-6 text-sm font-bold uppercase tracking-[0.25em] text-stone-600">
                        {item}
                        <Leaf size={14} className="text-emerald-800" />
                    </span>
                ))}
            </div>
        </div>
    );
}
